import { Injectable } from '@angular/core';
import { User } from '@app/core/interfaces';
import { environment } from '@env/environment';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private readonly cryptoKey: string = environment.cryptoKey;
  private tokenKey = '_t';
  private userIdKey = '_ui';
  private userNameKey = '_un';
  private userEmailKey = '_ue';
  private userPasswordKey = '_up';
  private userSuperuserKey = '_us';
  private searchColomnKey = '_sc';
  private searchFilterKey = '_sf';
  private searchEbayFilterKey = '_sef';

  private encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.cryptoKey).toString();
  }

  private decrypt(value: string | null): string | null {
    if(value === null) return null;
    return CryptoJS.AES.decrypt(value, this.cryptoKey).toString(CryptoJS.enc.Utf8);
  }

  get token(): string | null {
    return this.decrypt(localStorage.getItem(this.tokenKey));
  }

  set token(value: string) {
    localStorage.setItem(this.tokenKey, this.encrypt(value));
  }

  get userId(): string | null {
    return this.decrypt(localStorage.getItem(this.userIdKey));
  }

  set userId(value: string) {
    localStorage.setItem(this.userIdKey, this.encrypt(value));
  }

  get userName(): string | null {
    return this.decrypt(localStorage.getItem(this.userNameKey));
  }

  set userName(value: string) {
    localStorage.setItem(this.userNameKey, this.encrypt(value));
  }

  get userEmail(): string | null {
    return this.decrypt(localStorage.getItem(this.userEmailKey));
  }

  set userEmail(value: string) {
    localStorage.setItem(this.userEmailKey, this.encrypt(value));
  }

  get userPassword(): string | null {
    return this.decrypt(localStorage.getItem(this.userPasswordKey));
  }

  set userPassword(value: string) {
    localStorage.setItem(this.userPasswordKey, this.encrypt(value));
  }

  get userIsSuperuser(): boolean | null {
    return JSON.parse(this.decrypt(localStorage.getItem(this.userSuperuserKey)) as string) as boolean;
  }

  set userIsSuperuser(value: boolean) {
    localStorage.setItem(this.userSuperuserKey, this.encrypt(JSON.stringify(value)));
  }

  get searchColomn(): object | null {
    const value = localStorage.getItem(this.searchColomnKey);
    return value ? JSON.parse(value) : null;
  }

  set searchColomn(value: object) {
    localStorage.setItem(this.searchColomnKey, JSON.stringify(value));
  }

  get searchFilter(): object | null {
    const value = localStorage.getItem(this.searchFilterKey);
    return value ? JSON.parse(value) : null;
  }

  set searchFilter(value: object) {
    localStorage.setItem(this.searchFilterKey, JSON.stringify(value));
  }

  get searchEbayFilter(): object | null {
      const value = localStorage.getItem(this.searchEbayFilterKey);
      return value ? JSON.parse(value) : null;
  }

  set searchEbayFilter(value: object) {
      localStorage.setItem(this.searchEbayFilterKey, JSON.stringify(value));
  }

  get user(): User {
    return {
      id: this.userId || undefined,
      full_name: this.userName || undefined,
      email: this.userEmail || undefined,
      password: this.userPassword || undefined,
      is_superuser: this.userIsSuperuser || undefined
    }
  }

  set user(user: User) {
    this.userId = user.id || ''
    this.userName = user.full_name || ''
    this.userEmail = user.email || ''
    this.userPassword = user.password || ''
    this.userIsSuperuser = user.is_superuser || false
  }

  public clear(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userIdKey);
    localStorage.removeItem(this.userNameKey);
    localStorage.removeItem(this.userEmailKey);
    localStorage.removeItem(this.userPasswordKey);
    localStorage.removeItem(this.userSuperuserKey);
  }

  public clearAll(): void {
    localStorage.clear();
  }
}
